module.exports = __webpack_public_path__ + "static/img/p3.2d99b7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p3.jpg
// module id = E/fB
// module chunks = 1